import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Button } from '@netbasequid/core'
import SystemMessageLayout from 'components/wrapper/SystemMessageLayout'
import { Title, Content, ButtonContainer, Footer } from './Components'

const UnsubscribeResult = ({ dashboardName }: { dashboardName: string }) => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const domainName = window.location.origin

  return (
    <SystemMessageLayout>
      <Title>{t(`scheduledReportUnsubscribe.${state}.title`)}</Title>
      <Content>
        {t(`scheduledReportUnsubscribe.${state}.message`, {
          name: dashboardName,
          interpolation: {
            escapeValue: false
          }
        })}
      </Content>
      <ButtonContainer>
        <Button
          mode="dark"
          color="primary"
          onClick={() => {
            window.location.replace(`${domainName}/cb/nb/#Home/`)
          }}>
          {t('ok')}
        </Button>
      </ButtonContainer>
      <Footer>{t('quidCopyright', { year: new Date().getFullYear() })}</Footer>
    </SystemMessageLayout>
  )
}

export default UnsubscribeResult
